import { render } from "./tabbar.vue?vue&type=template&id=582cdd7a&ts=true"
import script from "./tabbar.vue?vue&type=script&lang=ts"
export * from "./tabbar.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__